import { render, staticRenderFns } from "./ViewEdit.vue?vue&type=template&id=967d16fc"
import script from "./ViewEdit.vue?vue&type=script&lang=ts"
export * from "./ViewEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('967d16fc')) {
      api.createRecord('967d16fc', component.options)
    } else {
      api.reload('967d16fc', component.options)
    }
    module.hot.accept("./ViewEdit.vue?vue&type=template&id=967d16fc", function () {
      api.rerender('967d16fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/ViewEdit.vue"
export default component.exports